// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, history, withRouter } from 'react-router-dom';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import PDFViewer from '../../../global/components/helpers/PDFViewer.js.jsx';

class ScenePDF extends Base {
  constructor(props) {
    super(props);
  }
  
  render() {
    const {
      courseId
      , match
      , openFollowups
      , scene
      , contentModuleId
      , hidden
    } = this.props;

    return (
      <PDFViewer
        file={scene.pdfPath}
        autoScroll={true}
        onDone={openFollowups}
        tracking={{
          _course: courseId
          , _contentModule: contentModuleId
          , _scene: scene._id
          , _node: match.params.nodeId
          , description: courseId ? 'user-node' : 'user-node-agenda'
        }}
        hidden={hidden}
      />
    )
  }
}

ScenePDF.propTypes = {
  courseId: PropTypes.string
  , openFollowups: PropTypes.func.isRequired
  , scene: PropTypes.object.isRequired
  , contentModuleId: PropTypes.string
  , hidden: PropTypes.bool.isRequired
}

ScenePDF.defaultProps = {
  courseId: null
  , contentModuleId: null
  , hidden: false
}

export default withRouter(ScenePDF);



// WEBPACK FOOTER //
// modules/scene/components/ScenePDF.js.jsx